module.exports = __webpack_public_path__ + "static/media/0.beginning.fe6325d7.mp4";